export default __webpack_public_path__ + "static/media/intenseheat.58257f02.png";